import { Box, Popover } from '@mui/material';
import { FunctionComponent, KeyboardEventHandler, MouseEvent, useState } from 'react';
import { UserTeamAvatar } from 'shared/UserTeamAvatar';
import { HeaderMenuContent } from './HeaderMenuContent/HeaderMenuContent';
import { HEADER_NAVIGATION_USER_BUTTON_ID } from 'components/Header/HeaderMenuToggle/constants';

type Content = 'navigation' | 'teams';

export const HeaderMenuToggle: FunctionComponent = () => {
  const [content, setContent] = useState<Content>('navigation');
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onUsernameKeyPress: KeyboardEventHandler<HTMLDivElement> = (event) => {
    if (event.key === 'Enter') {
      handleClose();
    }
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Box
        sx={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          userSelect: 'none',

          '&:focus': {
            outline: 'none',

            '&:focus-visible': {
              outline: '1px solid black',
            },
          },
        }}
        className="header__user-wrapper"
        aria-describedby={HEADER_NAVIGATION_USER_BUTTON_ID}
        data-testid={HEADER_NAVIGATION_USER_BUTTON_ID}
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={onUsernameKeyPress}
      >
        <UserTeamAvatar />
        <span>&nbsp;&#9660;</span>
      </Box>
      <Popover
        id={HEADER_NAVIGATION_USER_BUTTON_ID}
        data-testid="header-navigation-user-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 55,
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        TransitionProps={{
          mountOnEnter: true,
          onExited: () => {
            if (content !== 'navigation') {
              setContent('navigation');
            }
          },
        }}
      >
        <HeaderMenuContent content={content} onClose={handleClose} setContent={setContent} />
      </Popover>
    </>
  );
};
